import React, { useState, useEffect } from 'react';
import './InviteToBidModal.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.alooma.mg';

function InviteToBidModal({ influencerId, influencerName, onClose, onInvited }) {
  const [jobs, setJobs] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/api/jobs/my-jobs`, {
          headers: { 'Authorization': `Bearer ${token}` },
        });
        const data = await res.json();
        if (res.ok) {
          const openJobs = (data.jobs || []).filter(j => j.status === 'open');
          setJobs(openJobs);
          if (openJobs.length > 0) setSelectedJobId(openJobs[0].id);
        }
      } catch (err) {
        setError('Failed to load your jobs');
      } finally {
        setIsLoading(false);
      }
    };
    fetchJobs();
  }, []);

  const handleSend = async () => {
    if (!selectedJobId) {
      setError('Please select a job');
      return;
    }
    setIsSending(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/bids/invite`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ influencerId, jobId: selectedJobId, message }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Failed to send invitation');
      setSuccess('Invitation sent! A conversation has been started so you can chat.');
      if (onInvited) onInvited(data.conversationId);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="invite-modal-overlay" onClick={onClose}>
      <div className="invite-modal" onClick={(e) => e.stopPropagation()}>
        <button className="invite-modal-close" onClick={onClose}>×</button>
        <h2>Invite to Bid</h2>
        <p className="invite-modal-sub">
          Invite {influencerName || 'this creator'} to submit a bid on one of your open campaigns.
        </p>

        {isLoading ? (
          <div className="invite-loading">Loading your jobs...</div>
        ) : success ? (
          <div className="invite-success">
            <p>{success}</p>
            <button className="invite-send-btn" onClick={onClose}>Done</button>
          </div>
        ) : jobs.length === 0 ? (
          <div className="invite-empty">
            <p>You don't have any open jobs. Post a job first, then invite creators to bid.</p>
            <button className="invite-send-btn" onClick={onClose}>Close</button>
          </div>
        ) : (
          <>
            {error && <div className="invite-error">{error}</div>}
            <div className="invite-field">
              <label>Select a campaign</label>
              <select value={selectedJobId} onChange={(e) => setSelectedJobId(e.target.value)}>
                {jobs.map(job => (
                  <option key={job.id} value={job.id}>{job.title}</option>
                ))}
              </select>
            </div>
            <div className="invite-field">
              <label>Personal message (optional)</label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={4}
                placeholder="Add a note about why you'd love to work with this creator..."
              />
            </div>
            <div className="invite-actions">
              <button className="invite-cancel-btn" onClick={onClose} disabled={isSending}>Cancel</button>
              <button className="invite-send-btn" onClick={handleSend} disabled={isSending}>
                {isSending ? 'Sending...' : 'Send Invitation'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default InviteToBidModal;
